import RetrievalDocumentUploadForm from "./RetrievalDocumentUploadForm";
import { uploadToADLS } from "./VABondRetrieveShared";
import { RETRIEVE_PII_ACCESS } from "./bondRetrieveSharedPropTypes";

const VA_SECTIONS = [
  { label: "VA Letter *", name: "courtOrder" },
  { label: "Last Will", name: "lastWill" },
  { label: "Other Document", name: "otherDocument" },
  { label: "Bond Application", name: "bondApp" },
  { label: "Bond Document", name: "bond" },
  { label: "Indemnity Agreement", name: "indemnity" },
  { label: "Cancellation Document", name: "cancellationDocument" },
  { label: "Endorsement Document", name: "endorsementDocument" },
  { label: "Endorsement POA Document", name: "endorsementPOADocument" },
  { label: "Credit Report Document", name: "creditDocument" },
  { label: "FCRA Document", name: "fcraDocument" },
];

const VADocumentUploadForm = (props) => (
  <RetrievalDocumentUploadForm
    {...props}
    uploadToADLS={uploadToADLS}
    sections={VA_SECTIONS}
  />
);

VADocumentUploadForm.propTypes = RETRIEVE_PII_ACCESS;

export default VADocumentUploadForm;
